module.exports = __webpack_public_path__ + "img/bannersRedes05.984d3729.jpg";